import React, {useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTrashAlt, faCheck, faPencilAlt} from '@fortawesome/free-solid-svg-icons';
import UserForm from './UserForm';

const User = ({user, api}) => {

    const [editMode, setEditMode] = useState(false);

    const approveUser = async() => {
        await api.approveUser(user.id, user.display_name);
        // Use timeout to avoid retrieving same object, should be a better way
        setTimeout(() => api.getUsers(), 1000)
    }

    const deleteUser = async() => {
        await api.deleteUser(user.id, user.display_name);
        api.getUsers();
    }

    const editUser = () => {
        setEditMode(true);
    }

    const updateUser = async(username, groupId, password, passwordConfirmation) => {
        let result = await api.updateUser(username, groupId, password, passwordConfirmation);
        setEditMode(false);
        return result;
    }

    if (editMode) {
        return <tr>
            <td colSpan="6">
                <UserForm api={api} user={user} submitFunction={updateUser} cancelFunction={() => setEditMode(false)} requirePassword={false}></UserForm>
            </td>
        </tr>
    }

    return <tr>
        <th scope="row">{user.display_name}</th>
        <td>{(user.group_id && api.data.groups && api.data.groups.find(g => g.id === user.group_id)) ? api.data.groups.find(g => g.id === user.group_id).name : 'No Group'}</td>
        <td>{user.federated ? "Yes" : "No"}</td>
        <td>{user.admin ? ' Yes' : 'No'}</td>
        <td>{user.federated ? (user.approved ? ' Yes' : 'No') : 'N/A'}</td>
        <td>
            {user.federated && !user.approved && <button className="btn" onClick={approveUser}><FontAwesomeIcon className={`Outlet-icon`} icon={faCheck} title="Approve" /></button>}
        </td>
        <td className="text-right">
            <button className="btn" onClick={editUser}><FontAwesomeIcon className={`Outlet-icon`} icon={faPencilAlt} title="Edit" /></button>
            <button className="btn" onClick={deleteUser}><FontAwesomeIcon className={`Outlet-icon`} icon={faTrashAlt} title="Delete" /></button>
        </td>
    </tr>
}

export default User;